export const FULL_DATE_TIME_FORMAT = 'dddd, MMM DD YYYY HH:mm';
export const FULL_DATE_FORMAT = 'ddd, MMM D YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';